import {
  Cross2Icon,
  CheckCircledIcon,
  LockClosedIcon,
} from "@radix-ui/react-icons";
import React from "react";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { useQuestContext } from "../../context/QuestContext";
import { Task as TasksType, TaskType } from "../../types";
import { Invite } from "./Discord";
import { Verify } from "./Email";
import { PushSubscription } from "./Epns";
import { ThresholdScore } from "./Gitcoin";
import { Connect } from "./Github/Connect";
import { RestApi } from "./Offchain";
import { Graph } from "./Onchain";
import { Join } from "./Telegram";
import { Comment, Follow, Like, Post, Repost } from "./X";
import { Website } from "./Visit";
import useUser from "../../hooks/useUser";
import {
  Spinner,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@bandit-network/react-ui-kit";

export interface TaskProps {
  data: TasksType;
  isOpen: boolean;
  moduleId: string;
}

const Task: React.FC<TaskProps> = ({ data, isOpen, moduleId }) => {
  const {
    currentTaskId,
    tasksCompleted,
    setCurrentTaskId,
    setCurrentModuleId,
  } = useQuestContext();
  const isTaskComplete = tasksCompleted.includes(data?.id);
  const isActive = currentTaskId === data?.id;
  const { isWalletConnected } = useConnect();
  const { user, onXDisconnect, isDisconnecting, onDiscordDisconnect } =
    useUser();
  const onClickTask = () => {
    if (isActive) {
      setCurrentTaskId("");
      setCurrentModuleId("");
    } else {
      setCurrentTaskId(data?.id);
      setCurrentModuleId(moduleId);
    }
  };
  return (
    <div
      id={data?.id}
      className={`bad-quest_task__wrapper ${
        isOpen
          ? "bad-quest_task__wrapper--open"
          : "bad-quest_task__wrapper--close"
      }`}
    >
      {
        <div
          className={`bad-quest_task__not_open ${isWalletConnected ? " cursor-pointer" : ""}`}
          onClick={() => (!isWalletConnected ? null : onClickTask())}
        >
          <div className="bad-quest_task__not_open--left">
            <img
              src={`https://assets.bandit.network/assets/quest-tasks.svg#${
                data.type.split("_")[0]
              }`}
              className="bad-quest_task__not_open--task-icon"
              alt="task icon"
            />
            <p
              className={`bad-quest_task__not_open--left_title ${
                isTaskComplete &&
                "bad-quest_task__not_open--left_title_completed"
              }`}
            >
              {data.name}
            </p>
          </div>
          <div className="flex items-center">
            {isOpen &&
              (data.type === TaskType.X_LIKE ||
                data.type === TaskType.X_FOLLOW ||
                data.type === TaskType.X_POST ||
                data.type === TaskType.X_REPOST ||
                data.type === TaskType.X_COMMENT) &&
              user?.socialmedia?.twitter && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <div className="bad-quest_task__x">
                        <img
                          src={`https://assets.bandit.network/assets/quest-tasks.svg#twitter`}
                          alt="address"
                          className="bad-quest_task__x-icon"
                        />
                        <p className="bad-quest_task__x-username">
                          {user?.socialmedia?.twitter}
                        </p>
                        {isDisconnecting ? (
                          <Spinner className="ml-1 w-3 h-3 animate-spin" />
                        ) : (
                          <Cross2Icon
                            className="bad-quest_task__unlink_icon"
                            onClick={onXDisconnect}
                          />
                        )}
                      </div>
                      <TooltipContent>
                        <p>Disconnect X</p>
                      </TooltipContent>
                    </TooltipTrigger>
                  </Tooltip>
                </TooltipProvider>
              )}
            {isOpen &&
              data.type === TaskType.DISCORD_JOIN &&
              user?.socialmedia?.discord && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <div className="bad-quest_task__x">
                        <img
                          src={`https://assets.bandit.network/assets/quest-tasks.svg#discord`}
                          alt="address"
                          className="bad-quest_task__x-icon"
                        />
                        <p className="bad-quest_task__x-username">
                          {user?.socialmedia?.discord}
                        </p>
                        {isDisconnecting ? (
                          <Spinner className="w-4 h-4 animate-spin" />
                        ) : (
                          <Cross2Icon
                            className="bad-quest_task__unlink_icon"
                            onClick={onDiscordDisconnect}
                          />
                        )}
                      </div>
                      <TooltipContent>
                        <p>Disconnect Discord</p>
                      </TooltipContent>
                    </TooltipTrigger>
                  </Tooltip>
                </TooltipProvider>
              )}
            {isWalletConnected ? (
              <CheckCircledIcon
                className={`bad-quest_task__check_icon ${
                  isTaskComplete
                    ? "bad-quest_task__check_icon_completed"
                    : "bad-quest_task__check_icon_not_completed"
                }`}
              />
            ) : (
              <LockClosedIcon className="bad-quest_task__lock_icon" />
            )}
          </div>
        </div>
      }
      <div className="bad-quest_task__items">
        {/* 1. X (Twitter) */}
        {data.type.includes("twitter") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Like */}
            {data.type === TaskType.X_LIKE && <Like data={data} />}
            {/* Follow */}
            {data.type === TaskType.X_FOLLOW && <Follow data={data} />}
            {/* Post */}
            {data.type === TaskType.X_POST && <Post data={data} />}
            {/* Repost */}
            {data.type === TaskType.X_REPOST && <Repost data={data} />}
            {/* Comment */}
            {data.type === TaskType.X_COMMENT && <Comment data={data} />}
          </div>
        )}
        {/* 2. Discord */}
        {data.type.includes("discord") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Invite */}
            {data.type === TaskType.DISCORD_JOIN && <Invite data={data} />}
          </div>
        )}
        {/* 3. Telegram */}
        {data.type.includes("telegram") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Join */}
            {data.type === TaskType.TELEGRAM_JOIN && <Join data={data} />}
          </div>
        )}
        {/* 4. Email */}
        {data.type.includes("email") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Verify */}
            {data.type === TaskType.EMAIL_VERIFY && <Verify data={data} />}
          </div>
        )}
        {/* 5. Epns */}
        {data.type.includes("epns") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Push Subscription */}
            {data.type === TaskType.EPNS_SUBSCRIPTION && (
              <PushSubscription data={data} />
            )}
          </div>
        )}
        {/* 6. Gitcoin */}
        {data.type.includes("gitcoin") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Threshold Score */}
            {data.type === TaskType.GITCOIN_SCORE && (
              <ThresholdScore data={data} />
            )}
          </div>
        )}
        {/* 7. Onchain */}
        {data.type.includes("onchain") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Graph */}
            {data.type === TaskType.ONCHAIN_GRAPH && <Graph data={data} />}
          </div>
        )}
        {/* 8. Offchain */}
        {data.type.includes("offchain") && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Rest Api */}
            {data.type === TaskType.OFFCHAIN_REST_API && (
              <RestApi data={data} />
            )}
          </div>
        )}
        {/* 9. Github */}
        {data.type.includes("git_connect") && isOpen && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* connect */}
            {data.type === TaskType.GIT_CONNECT && <Connect data={data} />}
          </div>
        )}
        {/* 10. Visit */}
        {data.type.includes("visit") && isOpen && (
          <div
            className={`bad-quest_task__item ${
              isOpen ? "bad-quest_task__item-open" : "a"
            }`}
          >
            {/* Website */}
            {data.type === TaskType.VISIT_WEBSITE && <Website data={data} />}
          </div>
        )}
      </div>
    </div>
  );
};

export { Task };
